import React, { Fragment } from 'react'
import { connect } from 'react-redux'

import { ConfirmModal } from 'components/modals'
import EditEmployeeModal from './forms'
import actions from './actions'

const DialogsBase = ( props ) => {
  return (
    <Fragment>
      <EditEmployeeModal
        record={props.editModal.record}
        show={props.editModal.open}
        toggle={()=>props.employeeEditModalClose()}
        onChange={props.employeeRecordUpdate}
      />
      <ConfirmModal
        show={props.deleteModal.open}
        title="Confirm Delete Employee"
        message="Are you sure you want to delete this employee?"
        onSubmit={()=>props.employeeRecordDelete(props.deleteModal.record)}
        toggle={()=>props.employeeDeleteModalClose()}
      />
    </Fragment>
  )
}

export default connect(
  null,{
  ...actions,
})(DialogsBase);
